var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 12.8594C7.70001 12.8594 7.50001 12.7594 7.40001 12.5594C7.20001 12.3594 7.20001 12.1594 7.20001 11.9594C7.20001 11.6594 7.30001 11.4594 7.40001 11.3594C7.60001 11.1594 7.80001 11.1594 8.00001 11.1594C8.30001 11.1594 8.50001 11.2594 8.60001 11.3594C8.80001 11.5594 8.80001 11.7594 8.80001 11.9594C8.80001 12.2594 8.70001 12.4594 8.60001 12.5594C8.50001 12.7594 8.30001 12.8594 8.00001 12.8594ZM7.40001 10.2594L7.10001 4.85938H8.80001L8.60001 10.2594H7.40001Z",
    fill: "#DB3321"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.85938C11.9 1.85938 15 4.95937 15 8.85938C15 12.7594 11.9 15.8594 8 15.8594C4.1 15.8594 1 12.7594 1 8.85938C1 4.95937 4.1 1.85938 8 1.85938ZM8 0.859375C3.6 0.859375 0 4.45937 0 8.85938C0 13.2594 3.6 16.8594 8 16.8594C12.4 16.8594 16 13.2594 16 8.85938C16 4.45937 12.4 0.859375 8 0.859375Z",
    fill: "#DB3321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e0a5b5e80a77c15c9e7b3675e48ec088.svg";
export { ForwardRef as ReactComponent };